import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", href: "/" },
  { label: "Products", href: "/products" },
  { label: "Solutions", href: "/solutions" },
  { label: "How It Works", href: "/how-it-works" },
  { label: "Pricing", href: "/pricing" },
  { label: "About", href: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#070C18]/95 backdrop-blur-md border-b border-white/10 shadow-lg"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link className="flex items-center gap-2.5 shrink-0" to="/">
          <span className="text-white font-extrabold text-lg tracking-tight leading-tight">
            The Project<span className="text-electric-400"> Experts</span>
          </span>
        </Link>

        <ul className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => {
            const active = location.pathname === link.href;
            return (
              <li key={link.href}>
                <Link
                  className={`px-3.5 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    active
                      ? "text-electric-400 bg-electric-500/10"
                      : "text-slate-300 hover:text-white hover:bg-white/5"
                  }`}
                  to={link.href}
                >
                  {link.label}
                </Link>
              </li>
            );
          })}
        </ul>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            className="px-4 py-2 text-sm font-semibold text-white bg-electric-500 rounded-lg hover:bg-electric-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            to="/contact"
          >
            Book Free Assessment
          </Link>
        </div>

        <button
          className="lg:hidden w-9 h-9 flex items-center justify-center text-white cursor-pointer"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-3-line"}`}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="lg:hidden bg-[#070C18]/98 border-t border-white/10 px-6 py-4 flex flex-col gap-2">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="px-3 py-2.5 rounded-lg text-sm font-medium text-slate-300 hover:text-white hover:bg-white/5 transition-colors cursor-pointer"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="mt-2 px-4 py-3 text-sm font-semibold text-white bg-electric-500 rounded-lg hover:bg-electric-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
            onClick={() => setMenuOpen(false)}
          >
            Book Free Assessment
          </Link>
        </div>
      )}
    </header>
  );
}
